import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { BulkUpdateTasks } from '../../redux/taskSlice';
import { Menu, MenuTrigger, MenuPopover, MenuList } from '@fluentui/react-components';
import { Calendar16Regular, ChevronDown12Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';

const BulkDeadlineUpdateMenu = ({
    selectedRows,
    onBulkUpdateComplete,
    onRequestBulkDeadlineChange,
    schedulingEnabled = false,
    children,
}) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [deadline, setDeadline] = useState('');

    const applyDirectBulkUpdate = async updates => {
        await dispatch(
            BulkUpdateTasks({
                taskIds: selectedRows,
                updates,
                suppressToast: true,
            }),
        );
        if (onBulkUpdateComplete) {
            onBulkUpdateComplete({ deadline: updates.deadline ?? null }, selectedRows.length);
        }
        setOpen(false);
    };

    const handleBulkDeadlineUpdate = async () => {
        if (!selectedRows || selectedRows.length === 0) return;

        setIsUpdating(true);
        try {
            if (schedulingEnabled && onRequestBulkDeadlineChange) {
                await onRequestBulkDeadlineChange(selectedRows, deadline || null);
                setOpen(false);
                return;
            }
            await applyDirectBulkUpdate({ deadline: deadline || null });
        } catch (error) {
            console.error('Error updating bulk task deadline:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    const handleBulkDeadlineClear = async () => {
        if (!selectedRows || selectedRows.length === 0) return;

        setIsUpdating(true);
        try {
            if (schedulingEnabled && onRequestBulkDeadlineChange) {
                await onRequestBulkDeadlineChange(selectedRows, null);
                setOpen(false);
                return;
            }
            await applyDirectBulkUpdate({ deadline: null });
        } catch (error) {
            console.error('Error clearing bulk task deadline:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <Menu open={open} onOpenChange={(e, data) => setOpen(data.open)}>
            <MenuTrigger>
                {children || (
                    <div className={styles.bulkUpdateMenu} style={{ opacity: isUpdating ? 0.6 : 1 }}>
                        Deadline <ChevronDown12Regular className="ms-1" />
                    </div>
                )}
            </MenuTrigger>
            <MenuPopover style={{ width: '300px', minWidth: '300px' }}>
                <MenuList>
                    <div className="p-2">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <Calendar16Regular />
                            <span className={styles.tableFilterHeader}>Set Deadline</span>
                        </div>

                        <div className="mb-3">
                            <label className="form-label small mb-0" style={{ fontSize: '10px' }}>
                                Deadline
                            </label>
                            <input
                                type="date"
                                className={'form-control form-control-sm ' + styles.filterSelect}
                                value={deadline || ''}
                                onChange={e => setDeadline(e.target.value)}
                                disabled={isUpdating}
                            />
                        </div>

                        <div className="d-flex gap-2 justify-content-between">
                            <span
                                className={styles.secondaryBtnText + ' ms-1'}
                                onClick={handleBulkDeadlineUpdate}
                                style={{
                                    opacity: isUpdating ? 0.6 : 1,
                                    cursor: isUpdating ? 'not-allowed' : 'pointer',
                                }}>
                                Save deadline
                            </span>
                            <span
                                className={styles.secondaryBtnText + ' ms-1'}
                                onClick={handleBulkDeadlineClear}
                                style={{
                                    opacity: isUpdating ? 0.6 : 1,
                                    cursor: isUpdating ? 'not-allowed' : 'pointer',
                                }}>
                                Clear
                            </span>
                        </div>
                    </div>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default BulkDeadlineUpdateMenu;
